<template>
  <transition name="fade">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-dialog" role="document">
          <div class="modal-content isim-rounded overflow-hidden">
            <div class="modal-header">
              <h5 class="modal-title">Reset Password</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true" @click="close">
                  <i class="material-icons">close</i>
                </span>
              </button>
            </div>
            <div class="modal-body bg-light p-4">
              <p>
                Forgot your password? We can help by sending you a link to reset
                it. Please complete the following steps:
              </p>
              <ul>
                <li>Enter the email address on your iSimulate account</li>
                <li>
                  Select the
                  <b>Reset Password</b> button
                </li>
                <li>Check your inbox for a password reset email</li>
                <li>
                  Click on the link in the email and follow the instructions to
                  create a new password
                </li>
              </ul>

              <div class="alert alert-success" v-if="passwordSent">
                <strong>Success!</strong> If we found an account registered to
                that address, we have sent you an email with further
                instructions.
              </div>
              <div class="alert alert-danger" v-if="errorFound">
                <strong>Error.</strong> Couldn't reset password
              </div>

              <form @submit.prevent="requestPasswordReset">
                <div class="form-group">
                  <label for="emailInp"><b>Email address</b></label>
                  <input
                    type="email"
                    class="form-control"
                    v-model="emailEntered"
                    aria-describedby="emailHelp"
                    placeholder="example@example.com"
                    name="emailInp"
                  />
                  <small id="emailHelp" class="form-text text-muted">
                    We'll never share your email with anyone else.
                  </small>
                </div>
                <div class="modal-footer p-0">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click="close"
                  >
                    Cancel
                  </button>
                  <button
                    v-if="!passwordSent"
                    id="sendButton"
                    type="submit"
                    class="btn btn-primary"
                  >
                    {{ loading ? "..." : "Reset Password"}}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import UserService from "../services/user.service";
export default {
  name: "ForgotPasswordModal",

  data() {
    return {
      passwordSent: false,
      errorFound: false,
      loading: false,
      emailEntered: "",
    };
  },

  computed: {
    currentDistributor() {
      return this.$store.getters.getDistributor;
    },
  },

  methods: {
    close() {
      this.emailEntered = "";
      this.passwordSent = false;
      this.errorFound = false;
      this.$emit("close");
    },
    requestPasswordReset: function() {
      this.loading = true;
      this.passwordSent = false;

      UserService.requestPasswordReset(this.emailEntered, this.currentDistributor)
        .then(() => {
          this.passwordSent = true;
        })
        .catch(() => {
          this.errorFound = true;
          this.passwordSent = false;
        })
        .finally(() => this.loading = false);
    },
  },
};
</script>

<style>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}

.modal-header,
.modal-footer {
  padding: 20px;
  display: flex;
}

.modal-header {
  border-bottom: 1px solid #eeeeee;
  color: #007bff;
  justify-content: space-between;
}

.modal-footer {
  border: none;
  justify-content: flex-end;
}

.modal-body {
  position: relative;
  padding: 20px;
  text-align: left;
}

.btn-close {
  border: none;
  font-size: 20px;
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

.modal-wrapper {
  position: absolute;
  top: 6vh;
  right: 0;
  left: 0;
}
</style>
